import React from 'react';
import { Box, Typography, TextField } from '@mui/material';
import { colors, fonts, spacing } from '../../constants';

/**
 * BasicInfoSection Component
 * Basic information form section
 */
const BasicInfoSection = ({
  formData,
  errors,
  whatsappError,
  onInputChange,
  onWhatsAppChange,
  onWhatsAppKeyPress,
}) => {
  return (
    <>
      <Typography 
        variant="subtitle2" 
        sx={{ 
          fontWeight: fonts.weightSemiBold, 
          color: colors.textPrimaryDark, 
          fontSize: '13px',
          mb: '4px',
          mt: '4px',
        }}
      >
        Basic Information
      </Typography>

      <TextField
        required
        value={formData.name}
        onChange={onInputChange('name')}
        fullWidth
        size="small"
        placeholder="Full Name *"
        error={!!errors.name}
        helperText={errors.name || ''}
        InputProps={{
          sx: { 
            fontSize: '12px',
            '& input': {
              padding: '10px 12px',
              lineHeight: 1.4,
            }
          }
        }}
        FormHelperTextProps={{
          sx: { fontSize: '11px', marginTop: errors.name ? '4px' : '0px' }
        }}
      />

      <TextField
        required
        type="email"
        value={formData.email}
        onChange={onInputChange('email')}
        fullWidth
        size="small"
        placeholder="Email *"
        error={!!errors.email}
        helperText={errors.email || ''}
        InputProps={{
          sx: { 
            fontSize: '12px',
            '& input': {
              padding: '10px 12px',
              lineHeight: 1.4,
            }
          }
        }}
        FormHelperTextProps={{
          sx: { fontSize: '11px', marginTop: errors.email ? '4px' : '0px' }
        }}
      />

      <TextField
        type="password"
        value={formData.password}
        onChange={onInputChange('password')}
        fullWidth
        size="small"
        placeholder="Password (Optional - Auto-generated if left blank)"
        helperText="Leave empty to auto-generate a secure password. Login credentials will be emailed to the user."
        InputProps={{
          sx: { 
            fontSize: '12px',
            '& input': {
              padding: '10px 12px',
              lineHeight: 1.4,
            }
          }
        }}
        FormHelperTextProps={{
          sx: { fontSize: '11px' }
        }}
      />

      <TextField
        required
        value={formData.whatsappNumber}
        onChange={onWhatsAppChange}
        onKeyPress={onWhatsAppKeyPress}
        fullWidth
        size="small"
        placeholder="WhatsApp Number (10 digits) *"
        error={!!errors.whatsappNumber || !!whatsappError}
        helperText={errors.whatsappNumber || whatsappError || 'Enter 10-digit mobile number (required)'}
        inputProps={{
          maxLength: 10,
          inputMode: 'numeric',
          pattern: '[0-9]*',
        }}
        InputProps={{
          sx: { 
            fontSize: '12px',
            '& input': {
              padding: '10px 12px',
              lineHeight: 1.4,
            }
          }
        }}
        FormHelperTextProps={{
          sx: { fontSize: '11px', marginTop: (errors.whatsappNumber || whatsappError) ? '4px' : '0px' }
        }}
      />
    </>
  );
};

export default BasicInfoSection;

